export default {
  cultureMediaList: [],
};
